import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Card,
  Chip,
  Divider,
  CircularProgress,
  Pagination,
} from "@mui/material";

import { API_ENDPOINT } from "../../services/api/resources";
import SearchBar from "../../components/common/SearchBar/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
} from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

const UserLogs = () => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("created_at");

  const handleSort = () => {
    setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const ROWS_PER_PAGE = 10;

  const fetchAllUserLogs = async () => {
    try {
      const res = await axios.get(API_ENDPOINT.all_user_activity);

      setLogs(res?.data?.activities || []);
      setTotal(res?.data?.total_logs || 0);
    } catch (err) {
      console.error("All user activity error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUserLogs();
  }, []);

  const filteredLogs = logs
    .filter(
      (log) =>
        log.user_email.toLowerCase().includes(search.toLowerCase()) ||
        log.log_text.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();

      return order === "desc" ? dateB - dateA : dateA - dateB;
    });

  const paginatedLogs = filteredLogs.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE
  );

  return (
    <Box
      sx={{
        p: 4,
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        
      }}
    >
      {/* Header */}
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
          gap: 2,
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: "#2a68beff", fontWeight: "bold" }}
        >
          User Activity Logs
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <SearchBar
              value={search}
              onChange={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </Box>

          {/* Total logs after search */}
          <Typography
            sx={{
              fontSize: 15,
              fontWeight: "bold",
              color: "#0f0f0fff",
              whiteSpace: "nowrap",
            }}
          >
            Total Logs: {total}
          </Typography>
        </Box>
      </Box>

      <Typography
        sx={{
          fontSize: 13,
          color: "#6b7280",
          mb: 2,
        }}
      >
        Monitor activities across Users, Buyers, Buyer Admins and Vendors
      </Typography>

      {/* Table Header */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: 2, boxShadow: 2, mt: 2 }}
      >
        <Table sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgb(224, 233, 238)",
  
              }}
            >
              <TableCell sx={thStyle}>User Mail</TableCell>
              <TableCell sx={thStyle}>Name</TableCell>
              <TableCell sx={thStyle}>Role</TableCell>
              <TableCell sx={thStyle}>Activity</TableCell>
              <TableCell sx={thStyle} align="right">
                <TableSortLabel
                  active
                  direction={order}
                  onClick={handleSort}
                  IconComponent={UnfoldMoreIcon}
                >
                  Date & Time
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedLogs.length > 0 ? (
              paginatedLogs.map((log) => (
                <TableRow key={log.id} hover>
                  <TableCell sx={tdStyle}>{log.user_email}</TableCell>
                  <TableCell sx={tdStyle}>{log.name}</TableCell>

                  <TableCell sx={tdStyle}>{log.role}</TableCell>

                  <TableCell sx={tdStyle}>{log.log_text}</TableCell>

                  <TableCell sx={tdStyle} align="right">
                    {new Date(log.created_at).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  No activity found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={filteredLogs.length}
          page={page - 1}
          rowsPerPage={ROWS_PER_PAGE}
          rowsPerPageOptions={[10]}
          onPageChange={(_, newPage) => setPage(newPage + 1)}
          sx={{
            mt: 1.5,

            // Increase overall height
            "& .MuiTablePagination-toolbar": {
              minHeight: 64,
              paddingLeft: 8,
              paddingRight: 8,
            },

            // Increase text size
            "& .MuiTablePagination-displayedRows": {
              fontSize: "14px",
              fontWeight: 500,
            },

            "& .MuiTablePagination-selectLabel": {
              fontSize: "14px",
              fontWeight: 500,
            },

            // Increase arrow button size
            "& .MuiIconButton-root": {
              fontSize: "22px",
              padding: "10px",
            },

            // Disable small cramped look
            "& .MuiTablePagination-actions": {
              marginLeft: 16,
            },
          }}
        />
      </TableContainer>
    </Box>
  );
};

const thStyle = {
  fontSize: "14px",
  fontWeight: 600,
  border: "none",
  whiteSpace: "nowrap",
  fontFamily:"GilroyMedium"
};

const tdStyle = {
  fontSize: "14px",
  border: "none",
  color: "#1f2937",
  fontFamily:"GilroyMedium"
};

export default UserLogs;
